import {
  bluepurple,
  bluesky,
  gray,
  green,
  mint,
  orange,
  pink,
  purple,
  yellow,
} from '../tokens/colors';

import type { PublisherSubjects } from './types';

export const elicePalettes: PublisherSubjects = {
  korean: {
    elementary: {
      primary: bluepurple[300],
      background: bluesky[500],
      secondary: bluepurple[900],
      black: bluepurple[0],
      light: bluepurple[50],
    },
    middle: {
      primary: bluepurple[500],
      background: gray[400],
      secondary: bluepurple[900],
      black: bluepurple[0],
      light: bluepurple[50],
    },
    high: {
      primary: bluepurple[0],
      background: bluepurple[900],
      secondary: bluepurple[900],
      black: bluepurple[0],
      light: bluepurple[50],
    },
  },
  computerScience: {
    elementary: {
      primary: purple[300],
      background: bluesky[500],
      secondary: purple[900],
      black: purple[0],
      light: purple[50],
    },
    middle: {
      primary: purple[500],
      background: gray[400],
      secondary: purple[900],
      black: purple[0],
      light: purple[50],
    },
    high: {
      primary: bluepurple[0],
      background: purple[900],
      secondary: purple[900],
      black: purple[0],
      light: purple[50],
    },
  },
  english: {
    elementary: {
      primary: green[300],
      background: yellow[500],
      secondary: green[900],
      black: green[0],
      light: green[50],
    },
    middle: {
      primary: green[500],
      background: gray[400],
      secondary: green[900],
      black: green[0],
      light: green[50],
    },
    high: {
      primary: bluepurple[0],
      background: green[900],
      secondary: green[900],
      black: green[0],
      light: green[50],
    },
  },
  socialStudy: {
    elementary: {
      primary: orange[300],
      background: yellow[500],
      secondary: orange[900],
      black: orange[0],
      light: orange[50],
    },
    middle: {
      primary: orange[500],
      background: gray[400],
      secondary: orange[900],
      black: orange[0],
      light: orange[50],
    },
    high: {
      primary: bluepurple[0],
      background: orange[900],
      secondary: orange[900],
      black: orange[0],
      light: orange[50],
    },
  },
  math: {
    elementary: {
      primary: pink[300],
      background: yellow[500],
      secondary: pink[900],
      black: pink[0],
      light: pink[50],
    },
    middle: {
      primary: pink[500],
      background: gray[400],
      secondary: pink[900],
      black: pink[0],
      light: pink[50],
    },
    high: {
      primary: bluepurple[0],
      background: pink[900],
      secondary: pink[900],
      black: pink[0],
      light: pink[50],
    },
  },
  science: {
    elementary: {
      primary: mint[300],
      background: yellow[500],
      secondary: mint[900],
      black: mint[0],
      light: mint[50],
    },
    middle: {
      primary: mint[500],
      background: gray[400],
      secondary: mint[900],
      black: mint[0],
      light: mint[50],
    },
    high: {
      primary: bluepurple[0],
      background: mint[900],
      secondary: mint[900],
      black: mint[0],
      light: mint[50],
    },
  },
};
